var map = {
	"./arrange.svg": [
		46135,
		6135
	],
	"./assets.svg": [
		54549,
		4549
	],
	"./camera.svg": [
		21707,
		1707
	],
	"./check.svg": [
		53381,
		3381
	],
	"./check1.svg": [
		52429,
		2429
	],
	"./chevron-up.svg": [
		7643,
		7643
	],
	"./circle.svg": [
		32386,
		2386
	],
	"./click.svg": [
		80539,
		539
	],
	"./close.svg": [
		71111,
		1111
	],
	"./color-reset.svg": [
		38589,
		8589
	],
	"./color-select.svg": [
		89370,
		9370
	],
	"./component-add.svg": [
		83555,
		3555
	],
	"./condition.svg": [
		49979,
		9979
	],
	"./content-copy.svg": [
		52606,
		2606
	],
	"./copy.svg": [
		29824,
		9824
	],
	"./delete-outline.svg": [
		85621,
		5621
	],
	"./delete-page.svg": [
		6045,
		6045
	],
	"./dots-horizontal.svg": [
		3035,
		3035
	],
	"./dots-vertical.svg": [
		88223,
		8223
	],
	"./draw-rectangle.svg": [
		90707,
		707
	],
	"./edit.svg": [
		68559,
		8559
	],
	"./ellipse.svg": [
		15794,
		5794
	],
	"./erase.svg": [
		59616,
		9616
	],
	"./eraser.svg": [
		31450,
		1450
	],
	"./file-document-outline.svg": [
		96683,
		6683
	],
	"./file-download-outline.svg": [
		13222,
		3222
	],
	"./file-hidden.svg": [
		37451,
		7451
	],
	"./file-image-outline.svg": [
		49638,
		9638
	],
	"./file-link-outline.svg": [
		64928,
		4928
	],
	"./file-pdf-outline.svg": [
		43920,
		3920
	],
	"./file-powerpoint-outline.svg": [
		25823,
		5823
	],
	"./file-table-outline.svg": [
		80811,
		811
	],
	"./flash.svg": [
		64688,
		4688
	],
	"./grid-detection.svg": [
		17144,
		7144
	],
	"./grid-dots.svg": [
		93675,
		3675
	],
	"./grid-lines.svg": [
		69702,
		9702
	],
	"./grid-off.svg": [
		5109,
		5109
	],
	"./grid.svg": [
		54980,
		4980
	],
	"./help-circle.svg": [
		61505,
		1505
	],
	"./image-any.svg": [
		13603,
		3603
	],
	"./image-format.svg": [
		42544,
		2544
	],
	"./image-landscape.svg": [
		26329,
		6329
	],
	"./image-portrait.svg": [
		54566,
		4566
	],
	"./image-square.svg": [
		38562,
		8562
	],
	"./image.svg": [
		68774,
		8774
	],
	"./keyboard.svg": [
		82012,
		2012
	],
	"./label-outline.svg": [
		66554,
		6554
	],
	"./label.svg": [
		46028,
		6028
	],
	"./link.svg": [
		25497,
		5497
	],
	"./lock.svg": [
		54521,
		4521
	],
	"./logout-variant.svg": [
		90632,
		632
	],
	"./menu-down.svg": [
		97186,
		7186
	],
	"./message-alert.svg": [
		23956,
		3956
	],
	"./page-enter.svg": [
		25681,
		5681
	],
	"./page-leave.svg": [
		21234,
		1234
	],
	"./pen.svg": [
		48584,
		8584
	],
	"./plus.svg": [
		27678,
		7678
	],
	"./preview.svg": [
		50428,
		428
	],
	"./prototype.svg": [
		24958,
		4958
	],
	"./publish.svg": [
		23128,
		3128
	],
	"./qrcode.svg": [
		31538,
		1538
	],
	"./search.svg": [
		39612,
		9612
	],
	"./select-all.svg": [
		19877,
		9877
	],
	"./select-drag.svg": [
		15445,
		5445
	],
	"./select.svg": [
		28522,
		8522
	],
	"./target.svg": [
		6870,
		6870
	],
	"./tune-vertical.svg": [
		45611,
		5611
	],
	"./update.svg": [
		19686,
		9686
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75305;
module.exports = webpackAsyncContext;